import type { EbizioEventConfig } from '../types';
import { EBIZIO_EVENT_TYPE } from '../types';
import { logger } from '../utils';

export const savedBillingAddressDropdownOpenedConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.SAVED_BILLING_ADDRESS_DROPDOWN_OPENED,
  handler: ({ detail }) => {
    logger('Saved Billing Address Dropdown Opened');
    console.log(detail);
  },
};
